import {
  ShoppingBag, CirclePlus, Car, MapPin, CircleCheck, Star,
  CircleX, Gift, Settings, Bell,
} from 'lucide-react';

// Mirrors iOS NotificationType.icon + Notification.typeColor.
const META = {
  order_update: { Icon: ShoppingBag, cls: 'text-blue-500 bg-blue-500/10' },
  order_status: { Icon: ShoppingBag, cls: 'text-blue-500 bg-blue-500/10' },
  new_order: { Icon: CirclePlus, cls: 'text-blue-500 bg-blue-500/10' },
  driver_assigned: { Icon: Car, cls: 'text-green-500 bg-green-500/10' },
  driver_accepted: { Icon: Car, cls: 'text-green-500 bg-green-500/10' },
  driver_picked_up: { Icon: Car, cls: 'text-green-500 bg-green-500/10' },
  driver_on_the_way: { Icon: Car, cls: 'text-green-500 bg-green-500/10' },
  delivery_update: { Icon: Car, cls: 'text-green-500 bg-green-500/10' },
  driver_nearby: { Icon: MapPin, cls: 'text-orange-500 bg-orange-500/10' },
  driver_arrived: { Icon: MapPin, cls: 'text-orange-500 bg-orange-500/10' },
  order_ready: { Icon: CircleCheck, cls: 'text-orange-500 bg-orange-500/10' },
  order_completed: { Icon: Star, cls: 'text-green-500 bg-green-500/10' },
  delivery_completed: { Icon: Star, cls: 'text-green-500 bg-green-500/10' },
  order_cancelled: { Icon: CircleX, cls: 'text-red-500 bg-red-500/10' },
  promotion: { Icon: Gift, cls: 'text-purple-500 bg-purple-500/10' },
  system: { Icon: Settings, cls: 'text-gray-500 bg-gray-500/10' },
};

export function notificationMeta(type) {
  return META[type] || { Icon: Bell, cls: 'text-gray-500 bg-gray-500/10' };
}
